// API Configuration for CHC Frontend
const API_CONFIG = {
  development: {
    baseURL: 'http://localhost:8000',
    timeout: 10000,
    withCredentials: false,
  },
  production: {
    baseURL: process.env.REACT_APP_API_URL || 'https://api.your-domain.com',
    timeout: 10000,
    withCredentials: true,
  }
};

export const getApiConfig = () => {
  const env = process.env.NODE_ENV || 'development';
  return API_CONFIG[env];
};

// API endpoints configuration
export const API_ENDPOINTS = {
  // Authentication endpoints
  auth: {
    login: '/api/account/login/',
    logout: '/api/account/logout/',
    register: '/api/account/register/',
    profile: '/api/account/profile/',
    refresh: '/api/account/refresh/',
    passwordReset: '/api/account/password-reset/',
    passwordChange: '/api/account/password-change/',
  },
  
  // Client management
  client: {
    list: '/api/client/',
    detail: (id) => `/api/client/${id}/`,
    create: '/api/client/',
    update: (id) => `/api/client/${id}/`,
    delete: (id) => `/api/client/${id}/`,
    search: '/api/client/search/',
  },
  
  // Caregiver management
  caregiver: {
    list: '/api/caregiver/',
    detail: (id) => `/api/caregiver/${id}/`,
    create: '/api/caregiver/',
    update: (id) => `/api/caregiver/${id}/`,
    delete: (id) => `/api/caregiver/${id}/`,
    search: '/api/caregiver/search/',
    availability: (id) => `/api/caregiver/${id}/availability/`,
  },
  
  // Appointment management
  appointment: {
    list: '/api/appointment/',
    detail: (id) => `/api/appointment/${id}/`,
    create: '/api/appointment/',
    update: (id) => `/api/appointment/${id}/`,
    delete: (id) => `/api/appointment/${id}/`,
    cancel: (id) => `/api/appointment/${id}/cancel/`,
    reschedule: (id) => `/api/appointment/${id}/reschedule/`,
  },
  
  // Document management
  document: {
    list: '/api/document/',
    detail: (id) => `/api/document/${id}/`,
    create: '/api/document/',
    update: (id) => `/api/document/${id}/`,
    delete: (id) => `/api/document/${id}/`,
    upload: '/api/document/upload/',
    download: (id) => `/api/document/${id}/download/`,
  },
  
  // Payment management
  payment: {
    list: '/api/payments/',
    detail: (id) => `/api/payments/${id}/`,
    create: '/api/payments/',
    update: (id) => `/api/payments/${id}/`,
    delete: (id) => `/api/payments/${id}/`,
    process: (id) => `/api/payments/${id}/process/`,
    refund: (id) => `/api/payments/${id}/refund/`,
  },
  
  // Notification endpoints
  notification: {
    list: '/api/notifications/',
    markRead: (id) => `/api/notifications/${id}/mark-read/`,
    markAllRead: '/api/notifications/mark-all-read/',
  },
  
  // SMS endpoints
  sms: {
    send: '/api/sms/send/',
    status: (id) => `/api/sms/${id}/status/`,
  },
};

// API utility functions
export const API_UTILS = {
  // Get full URL for endpoint
  getFullUrl: (endpoint) => {
    const config = getApiConfig();
    return `${config.baseURL}${endpoint}`;
  },
  
  // Get API configuration for current environment
  getConfig: () => getApiConfig(),
  
  // Check if running in development
  isDevelopment: () => process.env.NODE_ENV === 'development',
  
  // Check if running in production
  isProduction: () => process.env.NODE_ENV === 'production',
  
  // Get environment name
  getEnvironment: () => process.env.NODE_ENV || 'development',
};

export default API_CONFIG;
